import { createStore } from "vuex";
import brandChannel from "./BrandChannelStore";
import tracking from "./TrackingStore";
import majesticTracking from "./MajesticTrackingStore";

const store = createStore({
  modules: {
    brandChannel,
    tracking,
    majesticTracking,
  },
});

export default store;
